import { useEffect, useState } from "react";
import * as Constants from "../../constants/urls";
import axios from "axios";
import { useCookies } from "react-cookie"; 
import HonariButton from "../Button/HonariButton";
import Select from "react-select";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

export const CategoryShipping = () => {
  const [response, setResponse] = useState(null);
  const [category, setCategory] = useState(undefined);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getCategoryList();
  }, []);

  const getCategoryList = () => {
    const url = Constants.apiUrl + "/api/category/list";
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setCategoryList(r.data.data);

        const categoryOptions = r.data.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setOptions(categoryOptions);
      })
      .catch((e) => {});
  };
  const create = () => {
    setLoading(true);
    const url = Constants.apiUrl + "/api/shipping/category/store";
    axios
      .post(
        url,
        {
          categoryId: category,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        setResponse(true);
        setLoading(false);

      })
      .catch((e) => {
        setResponse(false);
        setLoading(false);

      });
  };
  return (
    <>
      {" "}
      <Breadcrumb title={"ارسال ها غیر رایگان گروهی"} />
      <div className="flex flex-col gap-5 text-right p-5">
        {response == true && (
          <div className={"alert alert-success text-center"}>
            عملبات با موفقیت انجام شد
          </div>
        )}
        {response == false && (
          <div className={"alert alert-danger text-center"}>
            عملبات با شکست روبرو شد
          </div>
        )}

        <label>انتخاب دسته بندی</label>
        <Select
          options={options}
          isSearchable
          onChange={(e) => {
            setCategory(e.value);
          }}
        />

        <HonariButton disabled={loading} loading={loading} className={"w-full"} onClick={create}>
          ذخیره
        </HonariButton>

        <div className="flex justify-center">
          <div className={"alert alert-warning text-center"}>
            با انتخاب دسته بندی و ذخیره تمام محصولات دسته بندی به لیست اضافه
            میشوند !
          </div>
        </div>
      </div>
    </>
  );
};
